import { Component, Input } from '@angular/core';

@Component({
  selector: 'marina-loading-spinner',
  standalone: false,
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
  @Input() diameter: number = 50;
  @Input() message: string = 'Loading...';
  @Input() overlay: boolean = false;
}

